import React, { useState } from 'react';
import styled from 'styled-components';
import { config } from '../utils/config';

const DebugContainer = styled.div`
  position: fixed;
  top: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.9);
  color: white;
  padding: 12px;
  border-radius: 8px;
  font-size: 11px;
  font-family: 'JetBrains Mono', monospace;
  z-index: 9999;
  max-width: 320px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  ${props => props.isMinimized && `
    max-width: 40px;
    padding: 8px;
  `}
`;

const DebugTitle = styled.div`
  font-weight: bold;
  margin-bottom: 8px;
  color: #00ff88;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding-bottom: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: #ff6b6b;
  cursor: pointer;
  font-size: 14px;
  padding: 0;
  margin-left: 8px;
  
  &:hover {
    color: #ff4444;
  }
`;

const DebugItem = styled.div`
  margin: 4px 0;
  display: flex;
  justify-content: space-between;
  
  .key {
    color: #88ccff;
  }
  
  .value {
    color: ${props => props.isEnabled ? '#00ff88' : '#ff6b6b'};
    font-weight: bold;
  }
`;

const DebugConfig = () => {
  const [isMinimized, setIsMinimized] = useState(false);
  
  // Read directly from environment to avoid module loading issues
  if (process.env.REACT_APP_DEBUG !== '1') {
    return null;
  }

  if (isMinimized) {
    return (
      <DebugContainer isMinimized onClick={() => setIsMinimized(false)}>
        <div style={{ cursor: 'pointer' }}>🐛</div>
      </DebugContainer>
    );
  }

  return (
    <DebugContainer>
      <DebugTitle>
        🐛 Debug Config
        <CloseButton onClick={() => setIsMinimized(true)}>×</CloseButton>
      </DebugTitle>
      <DebugItem>
        <span className="key">REACT_APP_LOGIN:</span>
        <span className="value">{process.env.REACT_APP_LOGIN}</span>
      </DebugItem>
      <DebugItem isEnabled={config.login.enabled}>
        <span className="key">Login enabled:</span>
        <span className="value">{config.login.enabled ? 'YES' : 'NO'}</span>
      </DebugItem>
      <DebugItem>
        <span className="key">REACT_APP_DEBUG:</span>
        <span className="value">{process.env.REACT_APP_DEBUG}</span>
      </DebugItem>
      <DebugItem isEnabled={process.env.REACT_APP_DEBUG === '1'}>
        <span className="key">Debug enabled:</span>
        <span className="value">{process.env.REACT_APP_DEBUG === '1' ? 'YES' : 'NO'}</span>
      </DebugItem>
      <DebugItem>
        <span className="key">Business name:</span>
        <span className="value">{config.business.name}</span>
      </DebugItem>
      <DebugItem>
        <span className="key">Environment:</span>
        <span className="value">{process.env.NODE_ENV}</span>
      </DebugItem>
    </DebugContainer>
  );
};

export default DebugConfig;